import React, { useContext } from 'react';

import styles from './styles.module.scss';

export default function Toggle({
  state,
  onClick,
  className = '',
}: {
  state?: boolean;
  onClick?: () => void;
  className?: string;
}) {
  console.log('state==', state);
  return (
    <input
      className={`${styles.switch} ${className}`}
      type={`checkbox`}
      // defaultChecked={state}
      checked={state}
      onClick={onClick}
    />
  );
}
